import { MutableRefObject, useEffect } from "react"

/**
 * Hook to detect a click outside the component
 * @param ref 
 * @param callback 
 */
function useOutsideAlerter(ref: MutableRefObject<HTMLDivElement | null>, callback: () => void) 
{
    useEffect(() => {
        // Alert if clicked on outside of component
        const handleClickOutside = (event: any) => {
            if(ref.current && !ref.current.contains(event.target))
                callback()
        }
        
        // Add event listener for click
        document.addEventListener("mousedown", handleClickOutside)

        return () => {
            // Remove event listener for click
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [ref])
}

export default useOutsideAlerter
